import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/onboarding/v2/")({
  component: () => <Navigate to="/" replace />,
});
